import React, { useState } from 'react';
import { useDevicesEld } from '../../../../../Hooks/TT_ELD/Team/Devices';
import DevicesEldTable from './DevicesEldTable/DevicesEldTable';
import SearchInput from '../../../../../Utils/SearchInput';
import { Button, Select } from 'antd';
import SearchOptions from '../../../../../Utils/SearchOptions';
import { SearchResultForDevices } from '../../../../../Utils/SearchResults';
import useRouteQuery from '../../../../../Utils/useRouterQuery';
import { useTagQuerySync } from '../../../../../Utils/useTagQuerySync';

const roleList = [
  {
    label: 'IOS',
    value: 'IOS',
  },

  {
    label: 'Android ',
    value: 'Android',
  },
];

const DevicesEld = () => {
  const [skip, setSkip] = useState<number>(1);
  const [sortedInfo, setSortedInfo] = useState<any>({});
  const [userId, setUserId] = useState<string | number>('');
  const [userName, setUserName] = useRouteQuery('', 'userName', (v) => String(v));
  const [model, setModel] = useRouteQuery('', 'model', (v) => String(v));
  const [appVersion, setAppVersion] = useRouteQuery('', 'appVersion', (v) => String(v));
  const [versionCode, setVersionCode] = useRouteQuery('', 'versionCode', (v) => String(v));
  const [device, setDevice] = useRouteQuery('', 'device', (v) => String(v));
  const [sort, setSort] = useRouteQuery('', 'sort', (v) => String(v));

  const { Option } = Select;

  useTagQuerySync(
    { en_US: 'Devices ELD', zh_CN: '' },
    'devices-eld',
    { sortedInfo, userId, userName, model, appVersion, versionCode, device, sort, skip },
    {
      sortedInfo: setSortedInfo,
      userId: setUserId,
      userName: setUserName,
      model: setModel,
      appVersion: setAppVersion,
      versionCode: setVersionCode,
      device: setDevice,
      sort: setSort,
      skip: setSkip,
    },
  );

  const { data, isLoading, refetch } = useDevicesEld(
    userId,
    model,
    appVersion,
    versionCode,
    device,
    sort,
    // id ? id : 1,
    skip,
  );
  const onChange = (query: any) => {
    setSkip(query.current);
  };

  const handleChange = (event: string, inputName: string) => {
    const updateFunctions: Record<string, (value: string) => void> = {
      model: setModel,
      appVersion: setAppVersion,
      versionCode: setVersionCode,
    };

    if (updateFunctions[inputName]) {
      updateFunctions[inputName](event.trim());
      setSkip(1);
    }
  };

  const handleSearchSelect =
    (setter: (val: string | number) => void, nameSetter?: (val: string) => void) =>
    (val: any, { valId }: { valId: string }) => {
      setter(valId);
      nameSetter?.(val);
      if (valId) setSkip(1);
    };

  return (
    <div>
      <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <SearchOptions
          SearchResult={SearchResultForDevices}
          onSelect={handleSearchSelect(setUserId, setUserName)}
          placeholder="Search by driver"
          value={userName}
        />
        <SearchInput
          value={model}
          placeholder="Search by model"
          onDebounceChange={(event: string) => handleChange(event, 'model')}
        />
        <SearchInput
          value={appVersion}
          placeholder="Search by app version"
          onDebounceChange={(event: string) => handleChange(event, 'appVersion')}
        />
        <SearchInput
          value={versionCode}
          placeholder="Search by version code"
          onDebounceChange={(event: string) => handleChange(event, 'versionCode')}
        />
        <Select
          value={device ? device : 'all'}
          defaultValue="all"
          onChange={(value, option) => {
            setDevice(value === 'all' ? '' : value);
            setSkip(1);
          }}
          style={{ width: 200 }}
        >
          <Option key={'all'}>All Device</Option>
          {roleList.map((u: any, index: any) => (
            <Option key={index} value={u.value}>
              {u.label}
            </Option>
          ))}
        </Select>
        <Select
          value={sort ? sort : 'Is Active'}
          defaultValue="Is Active"
          onChange={(value, option) => {
            setSort(value === 'Is Active' ? '' : value);
            setSkip(1);
          }}
          style={{ width: 200 }}
        >
          <Option key={''} value="">
            Is Active
          </Option>
          <Option value="true">True</Option>
          <Option value="false">False</Option>
        </Select>
        <Button style={{ marginLeft: 'auto' }} size={'large'} onClick={() => refetch()}>
          Refresh
        </Button>
      </span>
      <DevicesEldTable
        data={data?.data}
        onChange={onChange}
        total={data?.count}
        isLoading={isLoading}
        setSortedInfo={setSortedInfo}
        sortedInfo={sortedInfo}
        setSort={setSort}
        sort={sort}
        setSkip={setSkip}
        skip={skip}
      />
    </div>
  );
};

export default DevicesEld;
